import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { MoreInfo as R } from "./index.es159.js";
import * as s from "@radix-ui/react-accordion";
import v from "classnames";
import { PADDING_MAPPING as W } from "./index.es765.js";
import e from "./index.es766.js";
import { useAccordionItemMoreInfo as _ } from "./index.es767.js";
import { useTheme as B } from "./index.es190.js";
import { Checkbox as E } from "./index.es31.js";
import { Thumbnail as F } from "./index.es126.js";
import { NotificationIndicator as U } from "./index.es99.js";
import { useScreenZoom as Z } from "./index.es589.js";
import { Heading as q } from "./index.es507.js";
import { BodyText as J } from "./index.es505.js";
import { UtilityChevronIcon as K } from "./index.es439.js";
const le = ({
  label: g,
  value: C,
  count: d,
  description: a,
  Icon: m,
  moreInfo: N,
  onSelection: n,
  Content: A,
  padding: f = 8,
  testId: r,
  itemPosition: o = "mid",
  ThumbnailSrc: c,
  isAccordionOfOne: h,
  isAboveSelected: I,
  isSelected: u,
  isCheckboxPartial: k,
  variant: y = "default",
  itemsHeadingLevel: M = "span",
  ...P
}) => {
  const { zoomPercentage: x } = Z(), l = B().spacings, { headingRef: L, moreInfoLeft: G, titleHolderRef: H } = _({
    ThumbnailSrc: c,
    description: a,
    padding: f,
    Icon: m,
    spacingMapping: l,
    onSelection: n,
    zoomPercentage: x
  }), $ = v(e.container, {
    [e.isFirstChild]: o === "first" && !h,
    [e.isLastChild]: o === "last" && !h,
    [e.isLastAndAboveIsOpen]: o === "last" && I,
    [e.isAccordionOfOne]: h,
    [e.isClean]: y === "clean"
  }), z = v(e.accordionContent, {
    [e.lastContent]: o === "last",
    [e.midContent]: o === "mid",
    [e.isClean]: y === "clean"
  }), T = !!c || !!m || !!n, b = (p) => {
    if (typeof p == "number") {
      const D = W[p];
      return l[D];
    }
    return l[p];
  }, j = b(f), w = {
    "--marginLeft": T ? b(f) : 0
  };
  return /* @__PURE__ */ i(s.Item, { value: C, "data-testid": r, ...P, children: [
    /* @__PURE__ */ t(
      s.Header,
      {
        className: $,
        style: { padding: `0 ${j}` },
        asChild: !0,
        children: /* @__PURE__ */ i("div", { children: [
          n && /* @__PURE__ */ t(
            E,
            {
              id: C + "-checkbox",
              onCheckedChange: n,
              testId: r + "-left-container-checkbox",
              checked: u,
              isPartial: k,
              "aria-label": "accordion item selection"
            }
          ),
          /* @__PURE__ */ i("div", { className: e.triggerAndMoreInfoWrapper, children: [
            /* @__PURE__ */ t(
              s.Trigger,
              {
                "data-testid": r + "-trigger",
                tabIndex: 0,
                "data-type": "accordion-info-container",
                className: e.accordionTrigger,
                asChild: !0,
                children: /* @__PURE__ */ i(
                  "button",
                  {
                    className: e.row,
                    style: { padding: `${l.md} 0px` },
                    children: [
                      /* @__PURE__ */ i(
                        "div",
                        {
                          className: e.left,
                          "data-testid": r + "-left-container",
                          children: [
                            m,
                            c && /* @__PURE__ */ t(
                              F,
                              {
                                size: a ? "medium" : "small",
                                src: c,
                                testId: r + "-left-container-thumbnail"
                              }
                            ),
                            /* @__PURE__ */ i("div", { className: e.textContainer, style: w, children: [
                              /* @__PURE__ */ t("div", { className: e.titleHolder, ref: H, children: /* @__PURE__ */ t(
                                q,
                                {
                                  variant: "h6",
                                  element: M,
                                  color: "primary",
                                  isEllipsis: !(x >= 200),
                                  "aria-label": g,
                                  "data-testid": r + "-left-container-label",
                                  ref: L,
                                  children: g
                                }
                              ) }),
                              a && /* @__PURE__ */ t(
                                J,
                                {
                                  variant: "regular",
                                  color: "secondary",
                                  element: "p",
                                  "data-testid": r + "-left-container-description",
                                  children: a
                                }
                              )
                            ] })
                          ]
                        }
                      ),
                      /* @__PURE__ */ i("span", { className: e.right, children: [
                        (!!d || d === 0) && /* @__PURE__ */ t(
                          U,
                          {
                            count: d,
                            limitAt: 99,
                            color: "gray",
                            testId: r + "-notification-indicator",
                            "aria-label": "accordion item notification indicator"
                          }
                        ),
                        /* @__PURE__ */ t(
                          K,
                          {
                            direction: "down",
                            type: "bold",
                            "aria-label": "accordion item chevron icon"
                          }
                        )
                      ] })
                    ]
                  }
                )
              }
            ),
            N && /* @__PURE__ */ t(
              "div",
              {
                className: e.moreInfoContainer,
                style: { left: `${G}px` },
                children: /* @__PURE__ */ t(R, { tooltip: N, testId: `${r}-more-info` })
              }
            )
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ t(s.Content, { className: z, children: /* @__PURE__ */ t("div", { className: e.contentWrapper, children: A }) })
  ] });
};
export {
  le as AccordionItem
};
//# sourceMappingURL=index.es644.js.map
